module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/icon_close-e3e897b2ab41381526645636cb77c833.png";